<script lang="ts">
  interface Props {
    headers?: string[];
  }

  let { headers = [] }: Props = $props();
</script>

<thead>
  <tr>
    {#each headers as header}
      <th class="table-head"><div class="head-val">{header}</div></th>
    {/each}
  </tr>
</thead>

<style>
  .table-head {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
    min-width: 100px;
    background-color: #f0f0f0;
  }
  .head-val {
    width: max-content;
  }
</style>
